import { Controller } from "@hotwired/stimulus"
import { track, BOOK_SHARE } from "../lib/analytics"

// Web Share API with a copy-to-clipboard fallback — used by the book detail
// page's "Compartilhar" button.
export default class extends Controller {
  static targets = ["label"]
  static values = { url: String, title: String, code: Number }

  async share() {
    const shareData = { title: this.titleValue, text: "Olha esse livro no Bookmania Sebo!\n", url: this.urlValue }

    if (navigator.share) {
      try {
        await navigator.share(shareData)
        this.trackShare()
        return
      } catch (err) {
        if (err.name === "AbortError") return
      }
    }

    if (navigator.clipboard?.writeText) {
      try {
        await navigator.clipboard.writeText(this.urlValue)
        this.flashLabel("Link copiado!")
        this.trackShare()
        return
      } catch {
        // cai para o estado padrão do botão
      }
    }
  }

  // Only fires once the link actually went somewhere — the Web Share sheet
  // succeeded, or the URL reached the clipboard. A click that opens the sheet
  // and is then dismissed raises AbortError and is not a share.
  trackShare() {
    track(BOOK_SHARE, { code: this.codeValue || null, title: this.titleValue })
  }

  flashLabel(text) {
    if (!this.hasLabelTarget) return
    const original = this.labelTarget.textContent
    this.labelTarget.textContent = text
    setTimeout(() => { this.labelTarget.textContent = original }, 2000)
  }
}
